function HumanResource(props) {

    return (
        <div className="recruit_contents">
            <div className="recruit_titleline_w">
                <h4 className="recruit_titleline_info">경영</h4>
                <h5 className="recruit_titleline_title">인사</h5>
            </div>
            <div className="recruit_subtitleline_w">
                <h6 className="recruit_titleline_info">직무소개</h6>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">직무 및 필요역량</h7>
                <p className="recruit_subinfo_text">
                    인사팀은 SBS의 모든 임직원에 대한 인사 관리와 인재 개발을 위한 교육을 주관합니다.<br />
                    구체적으로, 인사 관리는 조직개편, 승진, 인사이동, 채용, 근무태도, 급여/퇴직금, 상벌 제도 운영 등이 있고,<br />
                    교육 영역으로는 연수 및 교육제도 운영, 직무능력개발, 조직문화 형성 등이 있습니다.<br />
                    <br />
                    인사 업무는 SBS의 모든 구성원을 대상으로 하며, 직원이 입사하는 순간부터 퇴사하는 시점까지 직원과 함께하게 됩니다.<br />
                    따라서 인사업무의 가장  필수적인 역량으로 원활한 커뮤니케이션 능력을 꼽을 수 있습니다.<br />
                    업무를 하다 보면, 현업 부서와 인터뷰를 하거나 이슈에 대해서 회의를 하며 업무를 수행하는 경우가 많고,<br />
                    이 과정에서 상대방의 의견을 경청하며 명확하게 의사전달을 할 수 있는 커뮤니케이션 능력이 중요합니다.<br />
                    <br />
                    또한, 평가 및 보상 등의 업무는 업무 특성상 높은 신뢰도와 정확도가 요구되므로 꼼꼼한 성격을 지닌 지원자면 더욱 좋습니다.<br />
                    마지막으로, 인사관리의 바탕이 되는 노동법, 근로기준법 등 관련 법률을 열심히 배우고자 하는 학습 의지가 있으시다면,<br />
                    이미 충분히 지원할 자격을 갖추신 것으로 생각합니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">부서 소개</h7>
                <p className="recruit_subinfo_text">
                    인사팀은 미디어 산업에서 콘텐츠 제작의 핵심요소라고 할 수 있는 ‘인적자원’, 즉 사람에 대한 인사, 평가, 교육 등의 업무들을<br />수행하는 부서입니다.
                </p>
                <em className="recruit_bold_text">인사</em>
                <p className="recruit_subinfo_text">
                    회사의 근간이 되는 조직의 구성과 역할에 대해 고민하고, 이에 따른 조직개편과 인사발령 등을 수행합니다.<br />
                    또한, 인사 평가 등을 고려하여 정기 승진 인사 등을 단행하여 회사의 인적자원을 효율적으로 배치합니다.
                </p>
                <em className="recruit_bold_text">채용</em>
                <p className="recruit_subinfo_text">
                    직군별 신입 및 경력 채용을 진행하여 인재를 확보하고, 선발된 인재를 적재적소에 배치합니다.
                </p>
                <em className="recruit_bold_text">평가</em>
                <p className="recruit_subinfo_text">
                    SBS의 모든 직원은 한 해의 목표를 수립하고 연말에 달성 여부에 대한 성과평가를 받게 되는데, 이와 같은 평가 방식과 과정을<br />모두 주관합니다.
                </p>
                <em className="recruit_bold_text">보상</em>
                <p className="recruit_subinfo_text">
                    모든 임직원의 월별 급여 및 상여, 그리고 퇴직 시에는 퇴직금을 지급합니다. 또한, 연중에는 직원 동기부여를 위한
                    포상 및 인센티브 등<br />다양한 보상 제도를 운영합니다.
                </p>
                <em className="recruit_bold_text">교육</em>
                <p className="recruit_subinfo_text">
                    직원들의 역량 개발을 위해 국내외 연수 제도를 기획 및 운영하고, 개인 또는 단체 교육 등을 통해 인재를 육성합니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">커리어패스 및 비전</h7>
                <p className="recruit_subinfo_text">
                    미디어산업은 최근 더욱 빠르게 변화하고 있지만, 결국 그 경쟁력은 사람입니다.<br />
                    인사 담당자는 예능, 교양, 보도, 편성, 전략, 사업 등 회사 내 다양한 부서의 직원들과 소통하고,<br />
                    이를 통해 회사의 핵심역량인 인적 자원을 어떻게 관리하고, 어떤 방향으로 함께 성장해나갈지 고민합니다.<br />
                    인사 업무 담당자는 미디어 산업의 발전과 변화를 빠르게 파악할 수 있고, 각 부서의 역할과 미래 비전을 함께 구상할 수 있습니다.<br />
                    <br />
                    인사팀에서는 채용, 평가, 보상 등 여러 업무를 순환하며 HRM(인사관리)과 HRD(인재개발)를 모두 경험할 수 있고,<br />
                    이 과정에서 노무사 등의 전문 자격증 취득을 통해 업무의  전문성을 더할 수도 있습니다.<br />
                    인사 업무를 하면 사내 구성원들과 협업 능력이 향상되기 때문에, 향후 마케팅, 운영팀, 미디어사업팀 등 커뮤니케이션이 중요한 부서에<br />
                    배치되어 업무를 수행할 수 있습니다. 인사 업무에 전문성을 갖는 인사팀의 특성상, 향후 회사의 경영 파트 관리자나 그룹 내 자회사의<br />
                    관리자로서 파견 근무의 기회도 있습니다.
                </p>
            </div>
            <div className="recruit_subtitleline_w">
                <h6 className="recruit_titleline_info">선배인터뷰</h6>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">본인 소개</h7>
                <p className="recruit_subinfo_text">
                    SBS 인사팀에서 조직/인사관리를 담당하고 있는 박재효입니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">인사담당자가 된 계기는?</h7>
                <p className="recruit_subinfo_text">
                    입사 후 정책담당 부서와 전략 부서에서 일했는데, 두 부서 모두 회사에 기여할 수 있어  보람 있었지만,
                    시간이 지나면서 SBS와 같은<br />미디어기업의 경쟁력에서 거의 전부라고 할 수 있는 ‘사람’에 관한 일을 하고 싶다는 마음이 커졌습니다.<br />
                    다행히 SBS는 직원들의 장점과 희망 사항을 고려해 배치하는 인사제도를 가지고 있고,
                    회사에서 저의 열의를 인정해줘서 인사팀에서<br />일하게 됐습니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">본인의 일에서 보람을 느낄 때는?</h7>
                <p className="recruit_subinfo_text">
                    제가 채용 전형에 참여해 합격한 지원자들이 최종 입사하여 제작 현장과 현업 부서에 잘 적응하고,
                    좋은 퍼포먼스를 보이고 있다는<br />이야기를 들었을 때 가장 뿌듯합니다. 또한, 빠르게 변화하는 미디어 산업환경에 발맞춰 조직을 개편하고,
                    인사이동을 통해<br />SBS의 인적 자원을 적재적소에 배치하여 회사가 계속 성장하고 있음을 확인할 수 있을 때 큰 성취감을 느낍니다.<br />
                    <br />
                    SBS는 저연차 사원이라도 빠르게 본인의 전문 영역을 가질 수 있고, 성장을 지원하는 회사입니다.<br />
                    미디어업계 가장 높은 역량을 보유한 동료와 함께하는 것이야말로 SBS에서 경험할 수 있는 최고의 보람과 가치라고 생각합니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">입사지원자에게 해주고 싶은 말</h7>
                <p className="recruit_subinfo_text">
                    급여를 비롯한 복리후생은 업계 최고 수준입니다. 근무지 역시 목동, 상암 등 서울 주요 위치에 자리 잡고 있습니다.<br />
                    무엇보다 최고가 되고자 노력하는 동료들과 이를 적극 뒷받침하는 조직문화는 SBS의 가장 큰 강점입니다.<br />
                    SBS 입사는 미디어업계 커리어를 시작하고자 하는 지원자에게 최고의 기회가 될 것입니다.
                </p>
            </div>
        </div>);
}

export default HumanResource;

